
import type { SVGProps } from 'react';
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#263E6A"
      fillRule="evenodd"
      d="M19.333 3.333a1.333 1.333 0 1 1 0 2.665 1.333 1.333 0 0 1 0-2.665m-16.666 2h14c.031 0 .058-.013.088-.018a2.66 2.66 0 0 0 2.578 2.018 2.666 2.666 0 1 0 0-5.334c-1.248 0-2.287.861-2.578 2.019-.03-.004-.057-.018-.088-.018h-14a.667.667 0 1 0 0 1.333m16.666 15.333a1.332 1.332 0 1 1 0-2.665 1.332 1.332 0 0 1 0 2.665m0-4a2.66 2.66 0 0 0-2.578 2.019c-.03-.005-.057-.019-.088-.019h-14a.667.667 0 1 0 0 1.334h14c.031 0 .058-.014.088-.018A2.661 2.661 0 0 0 22 19.333a2.666 2.666 0 0 0-2.667-2.667m-10-3.333a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666m12-2h-9.427a2.66 2.66 0 0 0-2.573-2 2.66 2.66 0 0 0-2.572 2H2.667a.667.667 0 1 0 0 1.333H6.76a2.66 2.66 0 0 0 2.573 2 2.66 2.66 0 0 0 2.573-2h9.427a.667.667 0 0 0 0-1.333"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFilter;
